<template>
    <div class="mb-20 mb-lg-40">
        <v-row align="center">
            <v-col cols="12" sm="auto" class="d-flex align-center">
                <v-btn class="min-w-lg-120px mr-lg-2" outlined color="grey" @click="goToday">
                    <span class="color-grey font-weight-bold tit-txt">TODAY</span>
                </v-btn>
            </v-col>
            <v-col>
                <calendar-header-month v-if="type == 'month'" v-bind="{ value }" v-on="{ input }" />
                <calendar-header-week v-if="type == 'week'" v-bind="{ value }" v-on="{ input }" />
                <calendar-header-date v-if="type == 'category'" v-bind="{ value }" v-on="{ input }" />
            </v-col>
            <v-spacer />
            <v-col cols="auto" class="w-120px w-md-180px">
                <v-select :value="type" :items="types" v-bind="inputAttrs" v-on="{ change }" hide-details outlined/>
                <!-- <v-select :value="type" :items="types" label="유형" v-bind="inputAttrs" v-on="{ change }" /> -->
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { inputAttrs } from "@/assets/variables";

import CalendarHeaderMonth from "./calendar-header-month.vue";
import CalendarHeaderWeek from "./calendar-header-week.vue";
import CalendarHeaderDate from "./calendar-header-date.vue";

let types = [
    { text: "월", value: "month" },
    { text: "주", value: "week" },
    { text: "라인별", value: "category" },
];

export default {
    components: {
        CalendarHeaderMonth,
        CalendarHeaderWeek,
        CalendarHeaderDate,
    },
    props: {
        value: { type: String, default: Date.now().toDate() }, // date
        type: { type: String, default: "month" },
    },
    data: () => ({
        types,
        inputAttrs,
    }),
    methods: {
        input(date) {
            this.$emit("input", date);
        },
        change(type) {
            this.$emit("typeChange", type);
        },
        goToday() {
            this.$emit("input", Date.now().toDate());
        },
    },
};
</script>

<style>
</style>